import URIS from 'constants/uris';
import http from 'services/http';

get.operation = 'READ';
get.idFrom = 'ARGS';
export function get(country) {
  const uri = `${URIS.VALIDATIONS_SHIPPING_ORDERS}/${country}`;
  return http.get(uri).then(({ data }) => data);
}
